/**
 * Enumetation of available filters in dashboard view
 */
export enum DashboardFilterEnum {

    /**
     * Station is running
     */
    OK = 'OK',

    /**
     * Station has a trouble (EOS, System failure, battery low, etc )
     */
    TROUBLE = 'TROUBLE',

    /**
     * Station has a gas alarm situation
     */
    GAS = 'GAS',

    /**
     * Station did not sent a message the passed day
     */
    OFFLINE = 'OFFLINE',

    /**
     * Default filter
     */
    ALL = 'ALL'
}